export default
    {
        code:'CARBONCLICK',
        currencies:['NZD']
    }